class CharmsCustomizer extends HTMLElement {
  constructor() {
    super();

    const dataElement = this.querySelector(`#CharmsData-${this.dataset.productId}`);
    this.data = dataElement ? JSON.parse(dataElement.textContent) : { basePrice: 0, charms: {} };

    this.basePrice = this.data.basePrice;
    this.selectedCharms = new Map();
    this.charmsGroups = this.querySelectorAll('.product-charms-group');

    this.init();
  }

  init() {
    this.charmsGroups.forEach(group => {
      const groupKey = group.dataset.metafieldKey;
      this.selectedCharms.set(groupKey, new Map());

      group.addEventListener('click', (event) => {
        // If the click is on the external link, let the browser handle it and do nothing else.
        if (event.target.closest('.product-charms-item__external-link')) {
          return;
        }

        const charmElement = event.target.closest('.product-charms-item');
        if (charmElement) {
          this.toggleCharm(charmElement, groupKey);
        }
      });

      group.addEventListener('keydown', (event) => {
        if (event.code !== 'Enter' && event.code !== 'Space') return;

        const charmElement = event.target.closest('.product-charms-item');
        if (charmElement) {
          event.preventDefault();
          this.toggleCharm(charmElement, groupKey);
        }
      });
    });
  }

  toggleCharm(charmElement, groupKey) {
    const variantId = charmElement.dataset.variantId;
    const groupSelections = this.selectedCharms.get(groupKey);

    if (groupSelections.has(variantId)) {
      groupSelections.delete(variantId);
      charmElement.classList.remove('is-selected');
      charmElement.setAttribute('aria-checked', 'false');
    } else {
      const charmInfo = this.data.charms[variantId];
      if (!charmInfo) return;

      const charmData = {
        id: variantId,
        price: charmInfo.price,
        title: charmInfo.title
      };
      groupSelections.set(variantId, charmData);
      charmElement.classList.add('is-selected');
      charmElement.setAttribute('aria-checked', 'true');
    }

    this.updateState(groupKey);
    charmElement.blur(); // Remove focus to hide tooltip after click
  }

  updateState(groupKey) {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    let totalCharmsPrice = 0;
    let groupTotalPrice = 0;
    const selectedTitles = [];
    const cartItems = [{ id: productForm.querySelector('[name="id"]').value, quantity: 1 }];

    this.selectedCharms.forEach((selections, key) => {
      selections.forEach(charm => {
        totalCharmsPrice += charm.price;
        cartItems.push({ id: charm.id, quantity: 1 });

        if (key === groupKey) {
          groupTotalPrice += charm.price;
          selectedTitles.push(charm.title);
        }
      });
    });

    const groupElement = this.querySelector(`[data-metafield-key="${groupKey}"]`);
    if(groupElement) {
        const priceAddOnElement = groupElement.querySelector('.product-charms-group__price-add-on');
        const selectedInfoElement = groupElement.querySelector('.product-charms-group__selected-info');
        priceAddOnElement.textContent = groupTotalPrice > 0 ? `(+ ${this.formatMoney(groupTotalPrice)})` : '';
        selectedInfoElement.textContent = selectedTitles.join(', ');
    }

    const mainPriceElement = document.querySelector('.price-list--product > sale-price');
    if (mainPriceElement) {
      const srOnlySpan = mainPriceElement.querySelector('.sr-only');
      const srOnlyHTML = srOnlySpan ? srOnlySpan.outerHTML : '';
      const newTotalPrice = this.basePrice + totalCharmsPrice;
      mainPriceElement.innerHTML = `${srOnlyHTML}${this.formatMoney(newTotalPrice)}`;
    }

    const originalIdInput = productForm.querySelector('input[name="id"]:not([name*="["])');
    productForm.querySelectorAll('input[name^="items["]').forEach(input => input.remove());
    if (originalIdInput) originalIdInput.disabled = false;

    if (cartItems.length > 1) {
      if (originalIdInput) originalIdInput.disabled = true;
      cartItems.forEach((item, index) => {
        const idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = `items[${index}][id]`;
        idInput.value = item.id;
        productForm.appendChild(idInput);

        const qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = `items[${index}][quantity]`;
        qtyInput.value = item.quantity;
        productForm.appendChild(qtyInput);
      });
    }
  }

  formatMoney(priceInCents) {
    const settings = window.themeVariables?.settings;

    const format = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
    const formatMatch = format.match(/\{\{(.*?)\}\}|\[\[(.*?)\]\]/);
    const formatKey = formatMatch ? (formatMatch[1] || formatMatch[2]).trim() : 'amount';

    const formattedPrice = this.formatPrice(priceInCents, formatKey);

    return format.replace(/\{\{.*?\}\}|\[\[.*?\]\]/, formattedPrice);
  }

  formatPrice(priceInCents, formatKey) {
    const price = priceInCents / 100;
    const [integerPart, decimalPart] = (price.toFixed(2)).split('.');

    const addThousandsSeparator = (numberString, separator) => {
      return numberString.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    };

    switch (formatKey) {
      case 'amount_no_decimals':
        return addThousandsSeparator(Math.round(price).toString(), ',');

      case 'amount_with_comma_separator':
        return `${addThousandsSeparator(integerPart, '.')},${decimalPart}`;

      case 'amount_no_decimals_with_comma_separator':
        return addThousandsSeparator(Math.round(price).toString(), '.');

      case 'amount_with_apostrophe_separator':
        return `${addThousandsSeparator(integerPart, "'")}.${decimalPart}`;

      case 'amount_no_decimals_with_space_separator':
        return addThousandsSeparator(Math.round(price).toString(), ' ');

      case 'amount_with_space_separator':
        return `${addThousandsSeparator(integerPart, ' ')},${decimalPart}`;

      case 'amount_with_period_and_space_separator':
        return `${addThousandsSeparator(integerPart, ' ')}.${decimalPart}`;

      case 'amount':
      default:
        return `${addThousandsSeparator(integerPart, ',')}.${decimalPart}`;
    }
  }
}

customElements.define('charms-customizer', CharmsCustomizer);
